module.exports = __webpack_public_path__ + "img/slide-5.341f2034.png";